const initChooseLanguage = () => {
  const blockSelected = document.querySelector('[data-language-selected]');
  const buttons = document.querySelectorAll('[data-language-button]');

  if (!blockSelected || buttons.length === 0) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      if (window.innerWidth < 616) {
        buttons.forEach((button) => {
          button.classList.remove('is-active');
        });

        button.classList.add('is-active');

        return;
      }

      const dataBlockValue = blockSelected.getAttribute('data-language-selected');
      const hiddenButton = document.querySelector(`[data-language-button="${dataBlockValue}"]`);
      const dataButtonValue = button.getAttribute('data-language-button');

      hiddenButton.classList.remove('is-active');
      blockSelected.setAttribute('data-language-selected', dataButtonValue);
      blockSelected.textContent = dataButtonValue;
      button.classList.add('is-active');
    });
  });
};

export {initChooseLanguage};
